import{jsxs as o,jsx as e}from"react/jsx-runtime";import{styled as r}from"styled-components";import{Paging as t,ZoomButton as i}from"./MenuWidget.mjs";import{GRID_MENU_HEIGHT as s}from"./constants.mjs";import{gridMenuStyle as m}from"./style.mjs";const d=r.div`
  position: relative;
  height: ${s}px;
  overflow: hidden;
  background: url(images/toolbar.png) repeat-x 0px -1px #e3e3e3;
  border-left: 1px solid #cccccc;
  border-right: 1px solid #cccccc;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;function c({isZoomedIn:r,setIsZoomedIn:s,width:c,...n}){return o(d,{className:"grid-menu",style:m(r,c),children:[e(t,{...n}),e(i,{isZoomedIn:r,setIsZoomedIn:s})]})}export{c as GridMenu};
